import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, firstValueFrom, mergeMap, filter } from 'rxjs';
import { SessionService } from '../services';

export const SKIP_HEADER_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false
);

export const headerInterceptorFn: HttpInterceptorFn = (req, next) => {
  const skip = req.context.get(SKIP_HEADER_INTERCEPTOR);
  if (skip) {
    return next(req);
  }

  const sessionService = inject(SessionService);

  return from(firstValueFrom(sessionService.sessionData$)).pipe(
    filter((data) => data !== null),
    mergeMap((sessionData) => {
      if (!sessionData) {
        return next(req);
      }

      const clonedReq = req.clone({
        setHeaders: {
          SIGNATURE: sessionData.Signature || '',
          'ubo-user-ip': sessionData.UserIp || '',
        },
      });

      return next(clonedReq);
    })
  );
};
